// extracted by mini-css-extract-plugin
export default {"container":"N4NQX","mobile":"VzIru"};